export const dict_ru = {
  ru: {
    translation: {
      routes: {
        welcome: 'Главная',
        about: 'Описание',
        dashboard: 'Доски',
        user: 'Пользователь',
        board: 'Доска',
        signIn: 'Войти',
        signUp: 'Регистрация',
        ufo: 'UFO',
      },
      sign: {
        signIn: 'Авторизация',
        signUp: 'Регистрация',
        loginRequired: 'Требуется логин',
        password: 'Пароль',
        submit: 'Подтвердить',
        name: 'Имя',
        userName: 'Имя пользователя',
        nameRequired: 'Требуется имя пользователя',
        nameShort: 'Введенное имя слишком короткое',
        passwordRequired: 'Требуется пароль',
        passwordShort: 'Введеный пароль слишком короткий',
        email: 'Email',
        registration: 'Регистрация',
      },
      ufo: {
        notFound: 'Страница не найдена',
      },
      header: {
        signIn: 'Войти',
        signUp: 'Регистрация',
        logout: 'Выйти',
        lang: {
          title: 'Язык',
          english: 'Английский',
          russian: 'Русский',
        },
        theme: {
          title: 'Тема',
          light: 'Светлая',
          dark: 'Темная',
        },
      },
      welcome: {
        title: 'Kanban',
        description:
          'Инструмент управления вашими проектами. Обеспечивает визуальное представление задач и позволяет определить объем работы, тем самым повышая эффективность команды',
        interface: 'Простой, интуитивно понятный интерфейс',
        dragNDrop: 'Удобное управление досками с помощью Drag-n-drop',
        infinityBoards: 'Возможность создания бесконечного количества досок, колонок и задач',
        advantages: 'Преимущества',
      },
      user: {
        title: 'Профиль пользователя',
        nameInput: 'Ваше имя: ',
        email: 'Email',
        emailInput: 'Email: ',
        delete: 'Удалить пользователя',
        edit: 'Редактировать',
        cancel: 'Отмена',
        nameRequired: 'Требуется имя пользователя',
        nameShort: 'Введенное имя слишком короткое',
        password: 'Пароль',
        passwordRequired: 'Требуется пароль',
        passwordShort: 'Введеный пароль слишком короткий',
        save: 'Сохранить',
      },
      addBoard: {
        createBoard: 'Создать новую доску',
        boardName: 'Название доски',
        titleRequired: 'Требуется название',
        boardDescription: 'Описание доски',
        descriptionRequired: 'Требуется описание',
        submit: 'Подтвердить',
        cancel: 'Отмена',
      },
      addColumn: {
        createColumn: 'Создать новую колонку',
        columnName: 'Название колонки',
        titleRequired: 'Требуется название',
        submit: 'Подтвердить',
        cancel: 'Отмена',
      },
      addTask: {
        createTask: 'Создать новую задачу',
        taskName: 'Название задачи',
        titleRequired: 'Требуется название',
        taskDescription: 'Описание задачи',
        descriptionRequired: 'Требуется описание',
        assignedUser: 'Назначенный пользователь',
        submit: 'Подтвердить',
        cancel: 'Отмена',
      },
      infoTask: {
        close: 'Закрыть',
      },
      authError: {
        error: 'Ошибка авторизации',
        wrong: 'Неверный логин или пароль',
        tryAgain: 'Попробуйте снова',
      },
      editBoard: {
        edit: 'Редактировать',
        boardName: 'Название доски',
        titleRequired: 'Требуется название',
        boardDescription: 'Описание доски',
        submit: 'Подтвердить',
        cancel: 'Отмена',
      },
      editColumn: {
        edit: 'Редактировать',
        columnName: 'Название колонки',
        titleRequired: 'Требуется название',
        submit: 'Подтвердить',
        cancel: 'Отмена',
      },
      editTask: {
        edit: 'Редактировать',
        taskName: 'Название задачи',
        titleRequired: 'Требуется название',
        taskDescription: 'Описание задачи',
        assignedUser: 'Назначенный пользователь',
        submit: 'Подтвердить',
        cancel: 'Отмена',
      },
      editUser: {
        edit: 'Редактировать',
        name: 'Имя',
        nameRequired: 'Требуется имя',
        nameShort: 'Имя слишком короткое',
        email: 'Email',
        emailRequired: 'Требуется email',
        password: 'Пароль',
        passwordRequired: 'Требуется пароль',
        passwordShort: 'Пароль слишком короткий',
        submit: 'Подтвердить',
        cancel: 'Отмена',
      },
      modalSession: {
        session: 'Продолжительность сессии',
        tokenExpired: 'Время сессии истекло',
        understood: 'Принять',
      },
      registerError: {
        error: 'Ошибка регистрации',
        exist: 'Данный пользователь уже существует',
        tryAgain: 'Попробуйте снова',
      },
      remove: {
        remove: 'Удалить',
        sure: 'Вы уверены?',
        yes: 'Да',
        no: 'Нет',
      },
      board: {
        addColumn: 'Добавить колонку',
      },
      dashboard: {
        title: 'Доски',
        addBoard: 'Добавить доску',
      },
      errorFallback: {
        wrong: 'Что-то пошло не так',
        tryAgain: 'Попробуйте снова',
      },
      info: {
        team: 'Наша Команда',
        gudin_name: 'Андрей Гудин',
        gudin_info: 'Фронтэнд разработчик, любит котов. Дизайн, доски, колонки, задачи',
        yurkouski_name: 'Андрей Юрковский',
        yurkouski_info:
          "Фронтэнд разработчик. Сетевые запросы, redux, взаимодействие компонентов, drag'n'drop",
        SteGlaset_name: 'Даниил Хлыбов',
        SteGlaset_info: 'Фронтэнд разработчик. Тимлид команды. Контент, интернационализаия',
      },
    },
  },
};
